import React from 'react';
import { motion } from 'framer-motion';
import { getChainLogo } from '../ChainLogos';
import { useThemeMode } from '../../hooks/useThemeMode';

const chains = [
  { name: 'Ethereum', ticker: 'ETH', key: 'ethereum' },
  { name: 'Solana', ticker: 'SOL', key: 'solana' },
  { name: 'BNB Chain', ticker: 'BNB', key: 'bnb' },
  { name: 'Polygon', ticker: 'POL', key: 'polygon' },
  { name: 'Base', ticker: 'ETH', key: 'base' },
  { name: 'Hyperliquid', ticker: 'HYPE', key: 'hyperliquid' },
];

const Chains = () => {
  const { isDark } = useThemeMode();

  return (
    <section
      id="chains"
      className={`py-20 border-y ${isDark ? 'border-neutral-900' : 'border-neutral-200'}`}
      style={{ backgroundColor: isDark ? 'rgba(23,23,23,0.2)' : 'rgba(0,0,0,0.02)' }}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <motion.span
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            className="text-neutral-500 text-sm font-mono tracking-wider"
          >
            ECOSYSTEM SUPPORT
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            className={`text-3xl font-bold mt-2 ${isDark ? 'text-white' : 'text-neutral-900'}`}
          >
            Universal Compatibility
          </motion.h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {chains.map((chain, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              whileHover={{ y: -5 }}
              className={`flex flex-col items-center p-6 border rounded-sm transition-colors ${
                isDark ? 'border-neutral-800 hover:border-neutral-600' : 'border-neutral-200 hover:border-neutral-400'
              }`}
              style={{ backgroundColor: isDark ? '#0a0a0a' : '#ffffff' }}
            >
              <div className="mb-4 w-12 h-12 flex items-center justify-center">
                {getChainLogo(chain.key, 40)}
              </div>
              <h4 className={`font-bold text-sm ${isDark ? 'text-white' : 'text-neutral-900'}`}>{chain.name}</h4>
              <p className="text-xs text-neutral-500 font-mono mt-1">{chain.ticker}</p>
            </motion.div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className={`text-sm ${isDark ? 'text-neutral-400' : 'text-neutral-500'}`}>
            + USDC, USDT support across all chains.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Chains;
